// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__ufrPe","show":"BackToTop_show__zgPwP"};